(() => {
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const track = (event, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  };

  const addBundle = async (ids) => {
    const items = ids.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    const response = await fetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error('bundle-add-failed');
    return response.json();
  };

  const mount = (root) => {
    if (!root || root.dataset.bnsvMounted === 'true') return;
    root.dataset.bnsvMounted = 'true';

    const status = root.querySelector('[data-bnsv-status]');
    const panels = Array.from(root.querySelectorAll('[data-bnsv-panel]'));
    const thumbs = Array.from(root.querySelectorAll('[data-bnsv-thumb]'));
    const current = root.querySelector('[data-bnsv-current]');
    let active = 0;

    const showPanel = (index, shouldScroll = false, shouldTrack = true) => {
      const target = panels.find((panel) => Number(panel.dataset.bnsvPanel) === Number(index));
      if (!target) return;
      active = Number(index);
      panels.forEach((panel) => {
        const isActive = panel === target;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
        if (!isActive) panel.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.bnsvThumb) === active;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
      if (current) current.textContent = String(active + 1).padStart(2, '0');
      if (shouldScroll) root.querySelector('[data-bnsv-gallery]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (shouldTrack) track('pdp_media_select', { media_index: active + 1 });
    };

    showPanel(active, false, false);

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      const insideSee = Boolean(thumb.closest('.bnsv__see'));
      showPanel(thumb.dataset.bnsvThumb, insideSee);
    }));

    root.querySelector('.bnsv__thumbs')?.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const delta = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
      const next = (active + delta + panels.length) % panels.length;
      showPanel(next);
      thumbs.find((thumb) => Number(thumb.dataset.bnsvThumb) === next)?.focus();
    });

    root.querySelector('[data-bnsv-prev]')?.addEventListener('click', () => showPanel((active - 1 + panels.length) % panels.length));
    root.querySelector('[data-bnsv-next]')?.addEventListener('click', () => showPanel((active + 1) % panels.length));

    const seeTrack = root.querySelector('[data-bnsv-see-track]');
    root.querySelector('[data-bnsv-see-next]')?.addEventListener('click', () => {
      seeTrack?.scrollBy({ left: Math.max(180, seeTrack.clientWidth * 0.72), behavior: 'smooth' });
    });

    const paletteToggle = root.querySelector('[data-bnsv-palette-toggle]');
    const paletteOpeners = Array.from(root.querySelectorAll('[data-bnsv-palette-toggle],[data-bnsv-palette-open]'));
    const paletteTrack = root.querySelector('[data-bnsv-palette-track]');
    const paletteCards = Array.from(root.querySelectorAll('[data-bnsv-palette-card]'));
    const paletteTile = root.querySelector('.bnsv__extra-all[data-bnsv-palette-open]');
    const paletteControls = root.querySelector('[data-bnsv-palette-controls]');
    const paletteClosedLabel = paletteToggle?.textContent || 'WSZYSTKIE KOLORY →';
    const setPalette = (open, trigger = null) => {
      if (!paletteTrack || paletteCards.length === 0 || paletteOpeners.length === 0) return;
      paletteTrack.classList.toggle('is-expanded', open);
      paletteCards.forEach((card) => { card.hidden = !open; });
      if (paletteTile) paletteTile.hidden = open;
      if (paletteControls) paletteControls.hidden = !open;
      paletteOpeners.forEach((opener) => opener.setAttribute('aria-expanded', String(open)));
      paletteToggle?.classList.toggle('is-open', open);
      if (paletteToggle) paletteToggle.textContent = open ? 'ZWIŃ PALETĘ ↑' : paletteClosedLabel;
      if (open) {
        if (trigger === paletteTile) paletteControls?.querySelector('[data-bnsv-palette-next]')?.focus({ preventScroll: true });
        track('pdp_palette_expand', { product: window.location.pathname });
      } else {
        paletteTrack.scrollTo({ left: 0, behavior: 'smooth' });
        paletteToggle?.focus({ preventScroll: true });
      }
    };
    const movePalette = (direction) => {
      if (!paletteTrack) return;
      paletteTrack.scrollBy({ left: direction * Math.max(220, paletteTrack.clientWidth * 0.82), behavior: 'smooth' });
      track('pdp_palette_scroll', { direction: direction > 0 ? 'next' : 'previous' });
    };
    root.addEventListener('click', (event) => {
      const toggle = event.target.closest?.('[data-bnsv-palette-toggle]');
      const opener = event.target.closest?.('[data-bnsv-palette-open]');
      const close = event.target.closest?.('[data-bnsv-palette-close]');
      const previous = event.target.closest?.('[data-bnsv-palette-prev]');
      const next = event.target.closest?.('[data-bnsv-palette-next]');
      if (!toggle && !opener && !close && !previous && !next) return;
      event.preventDefault();
      event.stopPropagation();
      if (toggle) setPalette(!paletteTrack?.classList.contains('is-expanded'), toggle);
      if (opener) setPalette(true, opener);
      if (close) setPalette(false);
      if (previous) movePalette(-1);
      if (next) movePalette(1);
    }, true);

    paletteTrack?.addEventListener('keydown', (event) => {
      if (event.target !== paletteTrack || !paletteTrack.classList.contains('is-expanded')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        movePalette(-1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        movePalette(1);
      }
    });

    root.querySelectorAll('[data-bnsv-quick-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.disabled || !button.dataset.variantId) return;
        const original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'DODAJĘ…';
        if (status) status.textContent = 'DODAJĘ PRODUKT DO KOSZYKA…';
        try {
          await addBundle([button.dataset.variantId]);
          button.textContent = 'DODANO ✓';
          button.classList.add('is-added');
          if (status) status.textContent = 'DODANO DO KOSZYKA. MOŻESZ WYBIERAĆ DALEJ.';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          track('quick_add', { source: 'pdp_001_conversion', variant_id: button.dataset.variantId });
          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-added');
            button.innerHTML = original;
          }, 1600);
        } catch (error) {
          button.disabled = false;
          button.innerHTML = original;
          if (status) status.textContent = root.dataset.bundleError || 'NIE UDAŁO SIĘ DODAĆ.';
        }
      });
    });

    root.addEventListener('click', async (event) => {
      const button = event.target.closest?.('[data-bnsv-bundle-add]');
      if (!button || !root.contains(button) || button.disabled) return;
      const ids = (button.dataset.variantIds || '').split(',').filter(Boolean);
      if (ids.length !== 3) return;
      const original = button.innerHTML;
      button.disabled = true;
      if (status) status.textContent = root.dataset.bundleLoading || 'DODAJĘ SYSTEM…';
      try {
        await addBundle(ids);
        track('bundle_add', { source: 'pdp_simple_v2', item_count: ids.length });
        if (root.classList.contains('is-convert-001')) {
          if (status) status.textContent = 'DODANO BAZĘ, KOLOR I TOP. ZOSTAJESZ NA KARCIE PRODUKTU.';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          button.classList.add('is-added');
          button.innerHTML = '<span>DODANO 3 PRODUKTY ✓</span>';
          window.setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-added');
            button.innerHTML = original;
          }, 1800);
        } else {
          window.location.href = `${rootPath()}cart`;
        }
      } catch (error) {
        if (status) status.textContent = root.dataset.bundleError || 'NIE UDAŁO SIĘ DODAĆ.';
        button.disabled = false;
        button.innerHTML = original;
      }
    }, true);

    const stepCards = Array.from(root.querySelectorAll('[data-bnsv-step-card]'));
    const hoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)');

    const stopStep = (card, reset = false) => {
      const video = card?.querySelector('[data-bnsv-step-video]');
      const toggle = card?.querySelector('[data-bnsv-video-toggle]');
      if (!video) return;
      video.pause();
      if (reset) {
        try { video.currentTime = 0; } catch (error) { /* metadata not loaded yet */ }
      }
      card.classList.remove('is-playing');
      if (toggle) {
        toggle.textContent = '▶';
        toggle.setAttribute('aria-pressed', 'false');
      }
    };

    const playStep = async (card, context) => {
      const video = card?.querySelector('[data-bnsv-step-video]');
      const toggle = card?.querySelector('[data-bnsv-video-toggle]');
      if (!video) return;
      stepCards.forEach((other) => { if (other !== card) stopStep(other, true); });
      try {
        await video.play();
        card.classList.add('is-playing');
        if (toggle) {
          toggle.textContent = 'Ⅱ';
          toggle.setAttribute('aria-pressed', 'true');
        }
        track('video_start', { context: 'pdp_steps', interaction: context, step: stepCards.indexOf(card) + 1 });
      } catch (error) {
        stopStep(card);
      }
    };

    stepCards.forEach((card) => {
      const video = card.querySelector('[data-bnsv-step-video]');
      const toggle = card.querySelector('[data-bnsv-video-toggle]');
      if (!video || !toggle) return;
      toggle.addEventListener('click', async () => {
        if (card.classList.contains('is-playing')) stopStep(card);
        else await playStep(card, 'tap');
      });
      if (hoverPreview.matches) {
        card.addEventListener('mouseenter', () => playStep(card, 'hover'));
        card.addEventListener('mouseleave', () => stopStep(card, true));
      }
    });

    const splitRoot = root.querySelector('[data-bnsv-split]');
    if (splitRoot) {
      const splitSteps = Array.from(splitRoot.querySelectorAll('[data-bnsv-split-step]'));
      const splitPanels = Array.from(splitRoot.querySelectorAll('[data-bnsv-split-media]'));

      const activateSplit = async (index, interaction) => {
        const selected = Number(index);
        const target = splitPanels.find((panel) => Number(panel.dataset.bnsvSplitMedia) === selected);
        if (!target) return;

        splitPanels.forEach((panel) => {
          const isActive = panel === target;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));
          const video = panel.querySelector('[data-bnsv-split-video]');
          if (!isActive && video) {
            video.pause();
            try { video.currentTime = 0; } catch (error) { /* metadata not loaded yet */ }
          }
        });
        splitSteps.forEach((step) => {
          const isActive = Number(step.dataset.bnsvSplitStep) === selected;
          step.classList.toggle('is-active', isActive);
          step.setAttribute('aria-pressed', String(isActive));
        });

        const video = target.querySelector('[data-bnsv-split-video]');
        if (video) {
          try { await video.play(); } catch (error) { /* poster remains visible */ }
        }
        track('video_start', { context: 'pdp_split_steps', interaction, step: selected + 1 });
      };

      splitSteps.forEach((step) => {
        step.addEventListener('click', () => activateSplit(step.dataset.bnsvSplitStep, 'tap'));
        step.addEventListener('focus', () => activateSplit(step.dataset.bnsvSplitStep, 'focus'));
        if (hoverPreview.matches) step.addEventListener('mouseenter', () => activateSplit(step.dataset.bnsvSplitStep, 'hover'));
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries[0] && !entries[0].isIntersecting) {
            splitPanels.forEach((panel) => panel.querySelector('[data-bnsv-split-video]')?.pause());
          }
        }, { threshold: 0.02 });
        observer.observe(splitRoot);
      }
    }

    const primary = root.querySelector('[data-bnsv-primary-atc]');
    const mobilePrimary = root.querySelector('[data-bnsv-mobile-atc]');
    const sticky = root.querySelector('[data-bnsv-sticky-atc]');
    if (primary && sticky) {
      const updateSticky = () => {
        const footer = document.querySelector('footer');
        const footerNear = footer && footer.getBoundingClientRect().top < window.innerHeight + 80;
        const reference = mobilePrimary && window.matchMedia('(max-width: 749px)').matches ? mobilePrimary : primary;
        sticky.classList.toggle('is-visible', reference.getBoundingClientRect().bottom < 0 && !footerNear);
      };
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
    }

    root.querySelectorAll('.bnsv__accordions details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        root.querySelectorAll('.bnsv__accordions details').forEach((other) => {
          if (other !== detail) other.open = false;
        });
      });
    });
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-bnsv]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
